import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'layout-embed',
  templateUrl: './embed.component.html',
  styleUrl: './embed.component.scss'
})
export class EmbedLayoutComponent implements OnInit {
  ngOnInit(): void {
  }

}
